import {authenticationService} from "../AuthenticationService";
import axios from "axios";
import Config from "../../config/Config";

const doctorApi = {

    getAllData: async () => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/getAllData`,
            requestconfig
        );
    },

    downloadAndMergeFiles: async (filesLinks) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
                // responseType: 'arraybuffer'
            },
            responseType: 'arraybuffer',
            timeout: 60000,
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/downloadAndMergeFiles`,
            {filesLinks},
            requestconfig
        );
    },

    changeResource: async (patientID) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/changeResource/${patientID}`,
            {},
            requestconfig
        );
    },
    getRecommendedDoctorName: async (doctorID) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/refDoc/${doctorID}/getRecommendedDoctorName`,
            requestconfig
        );
    },
    getVisitSummaryReport: async (requestID) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/request/${requestID}/getVisitSummaryReport`,
            requestconfig
        );
    },
    getRequestSummaryReport: async (requestID) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/request/${requestID}/getRequestSummaryReport`,
            requestconfig
        );
    },

    newPatient: async (patient_data) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/patients/signup`,
            patient_data,
            requestconfig
        );

    },

    getRecommendedTreatment: async (treatment_data) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;

        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return (await axios.post(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/getRecommendedTreatment`,
            treatment_data,
            requestconfig
        ));
    },
    addRequestFromVisit: async (patientID) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/patients/${patientID}/addRequestFromVisit`,
            requestconfig
        );

    },
    EditRequestInfo: async (info, id) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/patients/${id}/EditRequestInfo`,
            info,
            requestconfig
        );

    },
    EditPaymentInfo: async (info, id) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/patients/${id}/EditPaymentInfo`,
            info,
            requestconfig
        );

    },
    editPatientEmail: async (patient_data) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/patients/changeEmail`,
            patient_data,
            requestconfig
        );

    },
    editPatientInsurance: async (patient_data) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/patients/editPatientInsurance`,
            patient_data,
            requestconfig
        );

    },
    editPatientPhone: async (patient_data) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/patients/changePhone`,
            patient_data,
            requestconfig
        );

    },
    generatePDFAPI: async (obj) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;

        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': '1ba54bc2-bf18-4e7f-8591-18639cd1a972',
            },
        };
        return (await axios.post(
            `https://v2.api2pdf.com/chrome/pdf/html`,
            obj,
            requestconfig
        ));
    },
    deleteFromAPI: async (obj) => {
        if (!authenticationService.currentUserValue)
            return;

        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': '1ba54bc2-bf18-4e7f-8591-18639cd1a972',

            },
        };
        return (await axios.delete(
            `https://v2.api2pdf.com/file/${obj.ResponseId}`,
            {},
            requestconfig
        ));
    },
    getTitrationStep: async (TitrationCode) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/getTitrationStep`,
            TitrationCode,
            requestconfig
        );
    },

    getLeumitRequests: async (currentPage,filter) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/${currentPage}/getLeumitRequests`,
            filter,
            requestconfig
        );
    },
    getLeumitDoneRequests: async (currentPage,filter) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/${currentPage}/getLeumitDoneRequests`,
            filter,
            requestconfig
        );
    },
    getAllStatuses: async () => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/getAllStatuses`,
            requestconfig
        );
    },

    getPatientID: async () => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/getPatientID`,
            requestconfig
        );
    },

    getAllMedications: async () => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/getAllMedications`,
            requestconfig
        );
    },
    getAllAllergics: async () => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/getAllAllergics`,
            requestconfig
        );
    },

    getAllProducts: async (val) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/getAllProducts`,
            requestconfig
        );
    },

    getAllCities: async (val) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/getAllCities`,
            requestconfig
        );
    },

    getAllICDDiagnose: async () => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/getAllICDDiagnose`,
            requestconfig
        );
    },

    getAllFilesForms: async () => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/getAllFilesForms`,
            requestconfig
        );
    },
    getAllLeumitFilesForms: async () => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/getAllLeumitFilesForms`,
            requestconfig
        );
    },
    deleteLeumitUploadedFiles: async (patient_id, Form_type_ID, requestID) => {
        let formData = new FormData()
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/patients/${patient_id}/${requestID}/FormType/${Form_type_ID}/deleteLeumitUploadedFiles`,
            formData,
            requestconfig
        );
    },
    getLeumitUploadedFile: async (filesList) => {
        let formData = new FormData()
        if (filesList.file) {
            formData.append("uploadedPatientFiles", filesList.file[0]);
        }
        let selectedCategory = filesList.selectedCategory
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'multipart/form-data;Boundary=---WebKitFormBoundary7MA4YWxkTrZu0gW',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/patients/${filesList.UserStorageID}/${filesList.RequestID}/Form_type_ID/${selectedCategory}/getLeumitUploadedFile`,
            formData,
            requestconfig
        );
    },
    getMedicalConditions: async () => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/getMedicalConditions`,
            requestconfig
        );
    },

    getAllSymptoms: async () => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/getAllSymptoms`,
            requestconfig
        );
    },

    getNextVisitDoc: async () => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/getNextVisitDoc`,
            requestconfig
        );
    },

    getAllPatients: async (body) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/getallpatients`,
            body,
            requestconfig
        );
    },

    getAllMyPatients: async () => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/getAllMyPatients`,
            requestconfig
        );
    },

    PatientVisit: async (patient_data, patient_id) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/patients/${patient_id}/profile`,
            patient_data,
            requestconfig
        );

    },

    addNewPatientVisit: async (patient_data, patient_id) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/patients/${patient_id}/addNewVisit`,
            patient_data,
            requestconfig
        );

    },

    getUploadedFile: async (filesList) => {
        let formData = new FormData()
        let namesArr = []
        filesList.file.map((item,index)=>{
            namesArr.push(filesList.file[index].name)
            formData.append("uploadedPatientFiles"+index, filesList.file[index]);
        })
        const jsonStr = JSON.stringify(namesArr);
        formData.append("body",jsonStr)
        let selectedCategory= filesList.selectedCategory
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'multipart/form-data;Boundary=---WebKitFormBoundary7MA4YWxkTrZu0gW',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/patient/${filesList.UserStorageID}/${filesList.RequestID}/selectedCategory/${selectedCategory}/getUploadedFile`,
            formData,
            requestconfig
        );
    },

    uploadProfilePng: async (filesList) => {
        let formData = new FormData()
        formData.append("uploadedPatientFiles", filesList.file);
        let selectedCategory = "profilePic"
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'multipart/form-data;Boundary=---WebKitFormBoundary7MA4YWxkTrZu0gW',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/patient/${filesList.UserStorageID}/selectedCategory/${selectedCategory}/uploadProfilePng`,
            formData,
            requestconfig
        );
    },

    getProfilePic: async (patientID) => {
        let formData = new FormData()
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'multipart/form-data;Boundary=---WebKitFormBoundary7MA4YWxkTrZu0gW',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/patient/${patientID}/getProfilePic`,
            formData,
            requestconfig
        );
    },

    getClinicProfilePic: async () => {
        let formData = new FormData()
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'multipart/form-data;Boundary=---WebKitFormBoundary7MA4YWxkTrZu0gW',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/getClinicProfilePic`,
            formData,
            requestconfig
        );
    },

    getAllUploadedFiles: async (patientID, requestID) => {
        let formData = {RequestID: requestID}
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'multipart/form-data;Boundary=---WebKitFormBoundary7MA4YWxkTrZu0gW',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/patient/${patientID}/${requestID}/getAllUploadedFiles`,
            {RequestID: requestID},
            requestconfig
        );
    },
    savePdfFile: async (patientID, requestID, html) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/patient/${patientID}/${requestID}/savePdfFile`,
            html,
            requestconfig
        );
    },

    deleteUploadedFiles: async (patient_id, fileToDelete) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/patient/${patient_id}/deleteUploadedFiles`,
            fileToDelete,
            requestconfig
        );
    },

    getPatientById: async (patient_id) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/patients/${patient_id}/profile`,
            requestconfig
        );
    },
    getPatientByRequestId: async (patient_id, requestID) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/patients/${patient_id}/request/${requestID}/profile`,
            requestconfig
        );
    },

    getHCPById: async (hcp_id) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/hcp/${hcp_id}/hcpProfile`,
            requestconfig
        );
    },

    deletePatient: async (patient_id) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.delete(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/patients/${patient_id}/profile`,
            requestconfig
        );

    },

    blockPatient: async (patient_id) => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/patients/${patient_id}/blockPatient`,
            requestconfig
        );

    },

    getAllCompletedPatients: async () => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/getallpatients?archive=true`,
            requestconfig
        );
    },

    getAllHCPs: async () => {
        if (!authenticationService.currentUserValue)
            return;
        let doctor = authenticationService.currentUserValue;

        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/HCPs/${doctor.profile.UserStorageID}/getAllHCP`,
            requestconfig
        );

    },

}


export default doctorApi;
